import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'followerCount',
  standalone: true
})
export class FollowerCountPipe implements PipeTransform {

  transform(value: number): string {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace('.0', '') + 'M';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1).replace('.0', '') + 'K';
    } else {
      return value.toString();
    }
  }
}